var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkEmailRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9999 79.1665C49.9999 63.0415 63.0416 49.9998 79.1666 49.9998C83.6666 49.9998 87.8749 51.0415 91.6666 52.8332V24.9998C91.6666 20.4165 87.9166 16.6665 83.3333 16.6665H16.6666C12.0833 16.6665 8.33325 20.4165 8.33325 24.9998V74.9998C8.33325 79.5832 12.0833 83.3332 16.6666 83.3332H50.3332C50.1249 81.9582 49.9999 80.5832 49.9999 79.1665ZM16.6666 24.9998L49.9999 45.8332L83.3333 24.9998V33.3332L49.9999 54.1665L16.6666 33.3332V24.9998ZM72.2499 91.6665L57.4999 76.9165L63.3749 71.0415L72.2082 79.8748L89.8749 62.2082L95.8333 68.0832L72.2499 91.6665Z",
    fill: "#69BEFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkEmailRead);
export default __webpack_public_path__ + "static/media/mark-email-read.04413743b32cd89af64ac2f113b613c8.svg";
export { ForwardRef as ReactComponent };